/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumKarte: {
    name: 'big-medium-karte';
    data: string;
} = {
    name: 'big-medium-karte',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M64 3a47 47 0 0 0-47 47c0 12.42 5.7 26.88 16.94 43a210.5 210.5 0 0 0 23.74 27.87 9 9 0 0 0 12.64 0A209.7 209.7 0 0 0 94.06 93C105.3 76.88 111 62.42 111 50A47 47 0 0 0 64 3m0 110C29.68 78.92 27 56.19 27 50a37 37 0 0 1 74 0c0 6.19-2.68 28.92-37 63"/><path d="M64 26.15c-12.66 0-23 10.65-23 23.74a23 23 0 1 0 45.92 0C87 36.8 76.66 26.15 64 26.15m0 36.7a12.82 12.82 0 0 1-13-13c0-7.41 6-13.7 13-13.7s13 6.29 13 13.74a12.82 12.82 0 0 1-13 12.96"/></svg>`,
};
